import * as Sentry from '@sentry/browser';
import { invokeApi } from '~/ApiClient';
import { ThunkAction } from '~/Store';

interface AccessToken {
	user: { id: string; email: string };
	impersonatedBy: { id: string; email: string; name: string } | null;
}

export function setupUserContext(
	fetcher: () => ThunkAction<Promise<{ accessToken: AccessToken }>, any>
): ThunkAction<void, any> {
	return async (dispatch) => {
		if (dispatch(invokeApi((apiClient) => apiClient.loadAccessToken())) === null) {
			return;
		}

		try {
			updateUserContext((await dispatch(fetcher())).accessToken);
		} catch (error) {
			// ignore error - its handled elsewhere
		}
	};
}

export function updateUserContext(accessToken: AccessToken | null): void {
	Sentry.configureScope((scope) => {
		scope.setUser(accessToken !== null ? mapAccessToken(accessToken) : null);
	});
}

const mapAccessToken = (accessToken: AccessToken) => {
	const { user, impersonatedBy } = accessToken;

	return {
		id: user.id,
		email: user.email,
		...(impersonatedBy !== null
			? {
					'Impersonated By User Id': impersonatedBy.id,
					'Impersonated By Email': impersonatedBy.email,
					'Impersonated By Name': impersonatedBy.name,
			  }
			: {}),
	};
};
